var select = document.querySelector('#customer-review-slider')

var glide = new Glide('.glide', {
  type: 'carousel',
  perView: 3,
  focusAt: 'center',
  breakpoints: {
    600: {
      perView: 1,
      peek: { before: 100, after: 30 },
    },
    800: {
      perView: 2
    }
  }
})


select.addEventListener('change', function (event) {
  glide.update({
    type: event.target.value
  })
})

glide.mount()